
































import { FetchQuestionsParams } from '@/resource/question/questions.store';
import { QuestionLanguage } from '@/resource/subject/subject.model';
import isArray from '@/utils/common/is-array';
import { DropdownOption, OnSubmitReturn } from '@/utils/form/form-input-typing';
import { Component, Prop, Vue } from 'vue-property-decorator';
import FilterDropdownItem from './FilterDropdownItem.vue';

@Component({
  components: { FilterDropdownItem },
})
export default class FilterDropdown extends Vue {
  @Prop({ required: true })
  questionsFilter: FetchQuestionsParams;

  @Prop({ required: true })
  fetchQuestions: (
    isResetPagination: boolean,
  ) => Promise<OnSubmitReturn | null>;

  languages = {
    name: 'languages',
    options: [
      {
        value: QuestionLanguage.english,
        text: 'English',
        isSelected: false,
      },
      {
        value: QuestionLanguage.malay,
        text: 'Malay',
        isSelected: false,
      },
    ],
  };

  difficulties = {
    name: 'difficulties',
    options: [
      {
        value: '1',
        text: 'mengingat',
        isSelected: false,
      },
      {
        value: '2',
        text: 'Memahami',
        isSelected: false,
      },
      {
        value: '3',
        text: 'Mengaplikasi',
        isSelected: false,
      },
      {
        value: '4',
        text: 'Menganalisis',
        isSelected: false,
      },
      {
        value: '5',
        text: 'menilai',
        isSelected: false,
      },
      {
        value: '6',
        text: 'mencipta',
        isSelected: false,
      },
    ],
  };

  sortBys = {
    name: 'sortBys',
    options: [
      { value: 'chapter-asc', text: 'Chapter ascending', isChecked: false },
      { value: 'chapter-desc', text: 'Chapter descending', isChecked: false },
      {
        value: 'difficulty-asc',
        text: 'Difficulty ascending',
        isChecked: false,
      },
      {
        value: 'difficulty-desc',
        text: 'Difficulty descending',
        isChecked: false,
      },
    ],
  };

  async onOptionSubmit(
    name: string,
    selectedOption: DropdownOption | DropdownOption[] | null,
  ) {
    if (isArray(selectedOption)) {
      const selectedOptions = selectedOption as DropdownOption[];

      if (name === 'languages') {
        this.questionsFilter.languages = selectedOptions.map(
          option => option.value as string,
        );
      }

      if (name === 'difficulties') {
        this.questionsFilter.difficulties = selectedOptions.map(
          option => option.value as string,
        );
      }
    } else {
      const singleSelectedOptions = selectedOption as DropdownOption | null;

      if (singleSelectedOptions) {
        if (name === 'sortBys') {
          this.questionsFilter.sortBy = singleSelectedOptions
            ? (singleSelectedOptions.value as string)
            : '';
        }
      }
    }

    await this.fetchQuestions(true);
  }
}
